export default {
    // 查询扩展元素信息接口
    listExtendElementInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listExtendElementInfo', params, response);
    },
    // 新增扩展元素信息接口
    insertExtendElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtendElement', params, response);
    },
    // 更新扩展元素信息接口
    updateExtendElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateExtendElement', params, response);
    },
    // 删除扩展元素信息接口
    deleteExtendElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/deleteExtendElement', params, response);
    },
    // 删除扩展元素信息接口
    deleteExtendElementBatch(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/deleteExtendElementBatch', params, response);
    },
    //校验元素标识是否重复
    checkElementFlg(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkElementFlg', params, response);
    },
    // 查询扩展元素信息接口
    getRegexList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/getRegexList', params, response);
    },
    // 查询扩展元素类型信息接口
    getElementTypeList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/getElementTypeList', params, response);
    },
    // 查询扩展元素信息接口
    getDictTypeList(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictTypeList', params, response);
    },
    // 查询扩展元素信息接口
    getDictValuesByType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictValuesByType', params, response);
    }
};
